import $ from "jquery";

const SearchFocus = (el) => {
    const $el = $(el);
    const $menu = $("#menu-primary-menu");
    const $toggleClass = "menu-main--search-focus";
    const $closeSearch = $(".js-close-search");

    $el.on("focus", function () {
        $(".menu-main").addClass($toggleClass);
    });

    $el.on("blur", function () {
        if ($el.val().trim() === "") {
            $menu.removeClass($toggleClass);
            $(".menu-main").removeClass($toggleClass);
        }
    });

    $closeSearch.on("click", function () {
        $el.val('');
        $menu.removeClass($toggleClass);
        $(".menu-main").removeClass($toggleClass);
    });
};

export default SearchFocus;
